export const shadow = {
  none: 'none',
  xxs: '0 1px 1px 0 rgba(0, 0, 0, 0.04)',
  xs: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
  sm: '0 1px 3px 0 rgba(0, 0, 0, 0.10), 0 1px 2px -1px rgba(0, 0, 0, 0.10)',
  md: '0 4px 6px -1px rgba(0, 0, 0, 0.10), 0 2px 4px -2px rgba(0, 0, 0, 0.10)',
  lg: '0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -4px rgba(0, 0, 0, 0.10)',
  xl: '0 20px 25px -5px rgba(0, 0, 0, 0.10), 0 8px 10px -6px rgba(0, 0, 0, 0.10)',
  xxl: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  xxxl: '0 35px 60px -15px rgba(0, 0, 0, 0.30)',
  inner: 'inset 0 2px 4px 0 rgba(0, 0, 0, 0.05)'
} as const;

export type ShadowKey = keyof typeof shadow;
